module.exports = __webpack_public_path__ + "img/icon__eye.12c3addd.svg";